import React, { Component } from 'react';
import '../assets/custom.css';
import '../assets/teachers.css';
import './Content.css';
import { withRouter } from 'react-router-dom';
import HeaderComponent from '../Shared/Header';
import REST from '../Shared/REST';
import ico_plus_green from '../assets/images/ico_plus_green.png';
import ico_view from '../assets/images/ico_view.png';
import FooterComponent from "../Shared/Footer";
import DialogBox from "../Shared/DialogBox";
import DeleteDialogBox from "../Shared/DeleteDialogBox";
import Select from 'react-select';

const levelOptions = [
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' },
    { value: '6', label: '6' },
    { value: '7', label: '7' },
    { value: '8', label: '8' },
    { value: '9', label: '9' },
    { value: '10', label: '10' },
    { value: '11', label: '11' },
    { value: '12', label: '12' },
];

const typeOptions = [
    { value: 'N', label: 'Narrative'},
    { value: 'E', label: 'Expository' },
];

const statusOptions = [
    { value: '|', label: 'Noun/Pronoun'},
    { value: '\\', label: 'Adjective' },
    { value: '/', label: 'Verb/Adverb' },
    { value: '>', label: 'Conjunction' },
    { value: '~', label: 'Determinent/Art'},
    { value: '^', label: 'Preposition' }
];

const getValue = (opts, val) => opts.find(o => o.value === val);

class MazeCreator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            passageTitle: '',
            level: '',
            passageType: '',
            version: 0,
            content:'',
            passage: '',
            deleted: 4, //unpublished
            oldPassageId: '',
            words: [],
            wordsArray: [],
            statuses: [],
            showNext: false
        };
        this.handleTitle = this.handleTitle.bind(this);
        this.handleLevel = this.handleLevel.bind(this);
        this.handleType = this.handleType.bind(this);
        this.handleContent = this.handleContent.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleWordStatusChange = this.handleWordStatusChange.bind(this);
        this.validate = this.validate.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {

    }

    handleTitle(event) {
        this.setState({ passageTitle: event.target.value });
    }

    handleLevel(event) {
        this.setState({ level: event.value });
    }

    handleType(event) {
        this.setState({ passageType: event.value });
    }

    handleContent(event) {
        this.setState({ content: event.target.value });
    }

    handleCancel(event) {
        this.props.history.push("/content/maze");
    }

    handleNext(event) {

        let wordsArray = this.state.content.replace(/\s\s+/g, ' ').trim().split(" ");
        this.setState({wordsArray:wordsArray});
        let words = [];
        let pureWords = [];
        let number = 1;
        let wordNumber = 1;

        wordsArray.map((item) => {
            if(number == 7) {
                let regex = /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g;
                let pureWord = item.replaceAll(regex, '').trim();
                if (pureWord) {
                    let wordStatus = {number: wordNumber, word: pureWord, status: ''};
                    words.push(wordStatus);
                    number = 1;
                    wordNumber++;
                }
            }else {
                number++;
            }
        });

        this.setState({showNext:true, words:words});

    }

    handleWordStatusChange(number, status) {
        let statuses=[];
        if(this.state.statuses[number]) {
            statuses = this.state.statuses.map((item, j) => {
                if (j === number) {
                    return status;
                } else {
                    return item;
                }
            });
        }else{
            statuses = this.state.statuses.map((item) => {
                    return item;
            });
            statuses[number-1] = status;
        }
        try{
            this.setState({statuses: statuses});
        }catch(e){
            alert(e);
        }
    }

    validate(){
        let valid=true;
        if(!this.state.passageTitle) valid=false;
        if(!this.state.level) valid=false;
        if(!this.state.passageType) valid=false;
        if(!this.state.content) valid=false;
        for(let i=0; i<this.state.words.length; i++){
            if(!this.state.statuses[i]){
                valid=false;
            }
        }
        return valid;
    }

    async handleSubmit(event) {
        if(this.validate()) {
            let passage = '';
            let statusNo = 0;
            for (let i = 0; i < this.state.wordsArray.length; i++) {
                if (i > 0 && (i % 7 == 0)) {
                    passage += this.state.statuses[statusNo].trim() + this.state.wordsArray[i].trim() + ' ';
                    statusNo++;
                } else {
                    passage += this.state.wordsArray[i].trim() + ' ';
                }

                console.log(this.state.statuses[statusNo]);
                console.log(this.state.wordsArray[i]);
                console.log(passage);
            }
            await this.setState({passage: passage});

            REST.createMazeContent(this.state).then((response) => {
                alert('Submitted successfully!');
            }, (error) => {
                alert('Fail to submit.');
            });
        }else{
            alert('Please fill in all fields');
        }
    }

    handleLogout = () => {
        REST.logout().then((response) => {
            localStorage.removeItem('token');
            this.props.history.push("/login");
        }, (error) => {
            this.props.history.push("/login");
        });
    }

    render() {
        let items = this.state.words;
        let listLength = items.length;
        const wordlist = items.map((item) => {
            return <WordItemComponent listLength = {listLength} number={item.number} word={item.word} status={item.status} handleStatusChange={this.handleWordStatusChange} />
        });
        return (
            <div>
                <HeaderComponent contentManagement={true}  logout={this.handleLogout} />
                <div className="section bgGrey">
                    <div className="container">
                        <div className="row">
                            <div className="form-center" style={{width: 250}}>
                                <h1>Maze Content Creator</h1>
                            </div>
                        </div>
                        <hr/>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-1">
                                        <label className="form-label" htmlFor="inputTitle">Title</label>
                                    </div>
                                    <div className="col-md-11">
                                        <input type="text" onChange={this.handleTitle} id="inputTitle" className={this.state.titleError + " form-control inputStyle1"} placeholder="Title" required />
                                    </div>
                                </div>
                                <div className="row" style={{marginTop: 15}}>
                                    <div className="col-md-1">
                                        <label className="form-label" htmlFor="selectLevel">Level</label>
                                    </div>
                                    <div className="col-md-5">
                                        <Select onChange={this.handleLevel} id="selectLevel" options={levelOptions} defaultValue={getValue(levelOptions, this.state.level)} className={this.state.levelError} isSearchable={false} />
                                    </div>
                                    <div className="col-md-1">
                                        <label className="form-label" htmlFor="selectType">Type</label>
                                    </div>
                                    <div className="col-md-5">
                                        <Select onChange={this.handleType} id="selectLevel" options={typeOptions} defaultValue={getValue(typeOptions, this.state.passageType)} className={this.state.typeError} isSearchable={false} />
                                    </div>
                                </div>
                                <div style={{marginTop: 5}}>
                                    <label className="form-label" htmlFor="selectLevel">Passage Content</label>
                                </div>
                                <div>
                                    <textarea onChange={this.handleContent} value={this.state.content} style={{width:'100%', height: '300px'}}></textarea>
                                </div>
                                <div className="form-center" style={{width: 150}}>
                                    Character Limit: <b>{1200- this.state.content.length}</b>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div id="navbar" className="navbar form-center" style={{width: 100, marginTop: 160}} onClick={this.handleNext}>
                                    <a className={"handBtn"}>
                                        {this.state.showNext?
                                            <span>Update</span>: <span>Next</span>
                                        }
                                    </a>
                                </div>
                                <div id="navbar" className="navbar form-center" style={this.state.showNext?{width: 100, marginTop: 30, marginLeft: 31 }:{width: 100, marginTop: 30, marginLeft: 23 }} onClick={this.handleCancel}>
                                    <a className={"handBtn"}>
                                        <span>Cancel</span>
                                    </a>
                                </div>
                            </div>
                            <div className="col-md-4">
                                {this.state.showNext?
                                    <div>
                                        <div width="" style={{height:440, overflow: "auto"}}>
                                            <table cellPadding="0" cellSpacing="0" border="0" width="100%">
                                                <thead>
                                                <tr className="clickable-row">
                                                    <th className="fitWidth">#</th>
                                                    <th className="fitWidth">Word</th>
                                                    <th >Status</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {wordlist}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div id="navbar" className="navbar form-center" style={{width: 100, marginTop: 20}} onClick={this.handleSubmit}>
                                            <a className={"handBtn"}>
                                                <span>Submit</span>
                                            </a>
                                        </div>
                                    </div>:null
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <FooterComponent/>
            </div>
        );
    }
}


class WordItemComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: ''
        }
        this.handleStatusChange = this.handleStatusChange.bind(this);
    }

    handleStatusChange(event) {
        this.props.handleStatusChange(this.props.number, event.value);
    }

    render() {
        return (
            <tr className="clickable-row">
                <td >{this.props.number}</td>
                <td >{this.props.word}</td>
                <td>
                    <Select  onChange={this.handleStatusChange} id="selectStatus" options={statusOptions} defaultValue={getValue(statusOptions, this.props.status)} menuPlacement = {"auto"} isSearchable={false} />
                </td>
            </tr>
        );
    }
}

export default withRouter(MazeCreator);


// WEBPACK FOOTER //
// ./src/ContentComponent/MazeCreator.js